import React, {Component} from 'react';
import ImageContainer from "./ImageContainer";
import PropTypes from "prop-types";
import GalleryContainer from "./GalleryContainer";
import VideoContainer from "./VideoContainer";
import CamContainer from "./CamContainer";
import TagContainer from "./TagContainer";

class Container extends Component {
  static propTypes = {
    post: PropTypes.object.isRequired,
    imageSize: PropTypes.string,
    section: PropTypes.string,
    tag: PropTypes.string
  };

  render() {
    const { post } = this.props;

    switch (post.type) {
      case "Image":
        return <ImageContainer {...this.props} />;
      case "Video":
        if (post.video_info.content_type === "gif") {
          return <ImageContainer {...this.props} />;
        }

        return <VideoContainer {...this.props} />;
      case "Gallery":
        return <GalleryContainer {...this.props} />;
      case "Cam":
        return <CamContainer {...this.props} />;
      case "Tag":
        return <TagContainer {...this.props} />;
      default:
        return "";
    }
  }
}

export default Container;